import { memo } from 'react';

import { type ClipType } from '@air/api/types';

import { PrivateWorkspaceAgentSelectAssetBoardListQueries } from '~/components/v2/components/workspace/workspace-agent-panel/components/select-asset/PrivateWorkspaceAgentSelectAssetBoardListQueries';
import { usePrivateWorkspaceAgentSelectAssetDropdown } from '~/components/v2/components/workspace/workspace-agent-panel/components/select-asset/usePrivateWorkspaceAgentSelectAssetDropdown';
import { useWorkspaceAgentComposerWorkspaceId } from '~/components/v2/components/workspace/workspace-agent-panel/composer-host/WorkspaceAgentComposerWorkspaceProvider';
import { WorkspaceAgentSelectAssetDropdown } from '~/components/v2/components/workspace/workspace-agent-panel/design-system/select-asset/WorkspaceAgentSelectAssetDropdown';
import { type WorkspaceAgentSelectAssetValue } from '~/components/v2/components/workspace/workspace-agent-panel/design-system/select-asset/workspaceAgentSelectAssetTypes';
import { type PrivateWorkspaceAgentBoardAssetSearchFilters } from '~/components/v2/components/workspace/workspace-agent-panel/queries/getPrivateWorkspaceAgentBoardAssetSearchFilters';

export type PrivateWorkspaceAgentSelectAssetDropdownBodyProps = {
  clipTypes?: readonly ClipType[];
  'data-testid'?: string;
  filters?: PrivateWorkspaceAgentBoardAssetSearchFilters;
  id?: string;
  onSelect: (item: WorkspaceAgentSelectAssetValue | null) => void;
};

export const PrivateWorkspaceAgentSelectAssetDropdownBody = memo(
  ({ clipTypes, 'data-testid': testId, filters, id, onSelect }: PrivateWorkspaceAgentSelectAssetDropdownBodyProps) => {
    const workspaceId = useWorkspaceAgentComposerWorkspaceId();
    const picker = usePrivateWorkspaceAgentSelectAssetDropdown({ clipTypes, filters, workspaceId });

    return (
      <WorkspaceAgentSelectAssetDropdown
        assetResults={picker.assetResults}
        boardResults={{
          ...picker.boardResults,
          boardListQueries: (
            <PrivateWorkspaceAgentSelectAssetBoardListQueries
              onSnapshot={picker.onListSnapshot}
              specs={picker.boardListQuerySpecs}
            />
          ),
        }}
        brandKits={picker.brandKits}
        data-testid={testId}
        id={id}
        onSelectBrandKit={picker.onSelectBrandKit}
        onValueChange={onSelect}
        selectedBrandKitId={picker.selectedBrandKitId}
      />
    );
  },
);

PrivateWorkspaceAgentSelectAssetDropdownBody.displayName = 'PrivateWorkspaceAgentSelectAssetDropdownBody';
